import React from 'react';
import { Button, Modal } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import modalContainer from 'packages/common/modalContainer';
import { useDeferredClose } from 'packages/hooks/useDeferredClose';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    deleteTextStyle: () => void;
};

const DeleteStyleModal = ({ isOpen, onClose, deleteTextStyle }: Props) => {
    const [shouldRender, onCloseAnimationEnd] = useDeferredClose(isOpen);
    const { translate } = useTranslate();

    const handleDeleteClick = () => {
        deleteTextStyle();
        onClose();
    };

    if (!shouldRender) {
        return null;
    }

    return (
        <Modal
            container={modalContainer}
            isOpen={isOpen}
            onCloseAnimationEnd={onCloseAnimationEnd}
            onClose={onClose}
            title={translate('editor.sidebar.shots.text.textStyle.modal.delete.title')}
            actionPrimary={
                <Button variant="danger" onClick={handleDeleteClick}>
                    {translate('editor.sidebar.shots.text.textStyle.delete')}
                </Button>
            }
            actionSecondary={
                <Button variant="secondary" onClick={onClose}>
                    {translate('editor.sidebar.shots.text.textStyle.cancel')}
                </Button>
            }
        >
            {translate('editor.sidebar.shots.text.textStyle.delete_warning')}
        </Modal>
    );
};

export default React.memo(DeleteStyleModal);
